import { stringPresent } from "@silversea-ssc/ui-components-react";
import { sanitizeString } from "../string";

export type PostsQuery = string & { _type: "PostsQuery" };

export default class PostsQueryBuilder {
  conditions: string[] = [];
  language = "en";

  constructor(initialQuery?: PostsQuery) {
    if (initialQuery) this.appendAndCondition(initialQuery);
  }

  filterByCategoryId(categoryId: string | undefined): PostsQueryBuilder {
    if (!categoryId) return this;
    return this.filterByCategoryIds([categoryId]);
  }

  filterByCategoryIds(categoryIds: string[]): PostsQueryBuilder {
    const codes = categoryIds.map(
      (code) => `mainCategoryId:"${sanitizeString(code)}"`
    );
    this.appendAndCondition(this.orConditions(codes));

    return this;
  }

  filterByClusterId(clusterId: string | undefined): PostsQueryBuilder {
    if (!clusterId) return this;
    return this.filterByClusterIds([clusterId]);
  }

  filterByClusterIds(clusterIds: string[]): PostsQueryBuilder {
    const codes = clusterIds.map(
      (code) => `clusterId:"${sanitizeString(code)}"`
    );
    this.appendAndCondition(this.orConditions(codes));

    return this;
  }

  filterByTagId(tagId: string | undefined): PostsQueryBuilder {
    if (!tagId) return this;
    return this.filterByTagIds([tagId]);
  }

  filterByTagIds(tagIds: string[]): PostsQueryBuilder {
    const codes = tagIds.map((code) => `tags._id:"${sanitizeString(code)}"`);
    this.appendAndCondition(this.orConditions(codes));

    return this;
  }

  filterByAuthorId(authorId: string | undefined): PostsQueryBuilder {
    if (!authorId) return this;
    return this.filterByAuthorIds([authorId]);
  }

  filterByAuthorIds(authorIds: string[]): PostsQueryBuilder {
    const codes = authorIds.map(
      (code) => `authors._id:"${sanitizeString(code)}"`
    );
    this.appendAndCondition(this.orConditions(codes));

    return this;
  }

  excludeAIPosts(exclude: boolean): PostsQueryBuilder {
    if (exclude) this.appendAndCondition("hiddenFromUserSearch:false");

    return this;
  }

  private appendAndCondition(condition: string) {
    this.conditions.push(condition);
  }

  private orConditions(conditions: string[]) {
    return `(${conditions.join(" OR ")})`;
  }

  private andConditions(conditions: string[]) {
    return `(${conditions.join(" AND ")})`;
  }

  generate(): PostsQuery {
    return this.conditions
      .filter(this.filterEmptyCondition)
      .join(" AND ") as PostsQuery;
  }

  private filterEmptyCondition(condition: string): boolean {
    return stringPresent(condition) && condition != "()";
  }
}
